import { ReportState } from "./types";

export function getDefaultState(): ReportState {
	return {
		AvailableReports: [],
		Report: {},
		RelativeDaysToReport: 7,
		CurrentReportUrl: "",
		ResultCount: 10,
		ReportLoadingStatus: false,
		ReportErrorStatus: false,
		ReportApiEndpoint: "",
		ReportTypes: [],
		ReportDateFormatPref: false,
		CustomReportModal: {
			shown: false,
			insightID: 0,
			isShared: false
		},
		ShareCustomReportModal: {
			shown: false,
			insightID: 0,
			reportName: ""
		},
		ShareWithUsers: [],
		FavoriteReportModal: {
			shown: false,
			favoriteID: 0,
			currentUrl: "",
			reportPermalink: ""
        },
        FavoriteReports: [],
		ReportHistoryModal: {
			shown: false
		}
	};
}
